query getVerification( $start_date: Float, $end_date: Float, $country: String, $kyc_status: String, $search: String, $type: String) {
    getVerification(start_date: $start_date, end_date: $end_date, country: $country, kyc_status: $kyc_status, search: $search, type: $type) 
}
